import { Box, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ActivityBarChart from "../ActivityBarChart";
import { UserContext } from "../../../context/UserContext";
import UserProfile from "../../User/UserProfile";
import ThriveModal from "../../common/ThriveModal";
import CloseIcon from "@mui/icons-material/Close";
import IDEACoreCRM from "../../IDEACoreCRM/IDEACoreCRM";
import DateFilterForm from "./DateFilterForm";
import dayjs, { Dayjs } from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import utc from "dayjs/plugin/utc";
import CaseCard from "../../IDEACoreCRM/CaseCard";
import FirmReportPdf from "../../FirmReport/FirmReportPdf";
import BFCReportPdf from "../../BFCReport/BFCReportPdf";
import AllBFCReport from "../../BFCReport/AllBFCReport";
import { axiosInstance, fetchInstance } from "../../../utils/networking";
import InteractiveBarChart from "./InteractiveBarChart";
dayjs.extend(utc);
dayjs.extend(dayOfYear);

export const userOrder = [
  // "andrewsa@oaklandthrive.org",
  "peguesed@oaklandthrive.org",
  "brayj@oaklandthrive.org",
  "garcias@oaklandthrive.org",
  "desanctisj@oaklandthrive.org",
  "ibej@oaklandthrive.org",
  "dockhamj@oaklandthrive.org",
  "kregerj@oaklandthrive.org",
  "lyonsm@oaklandthrive.org",
  "williamst@oaklandthrive.org",
  "beckerb@oaklandthrive.org",
  "tellezd@oaklandthrive.org",
  "bauerd@oaklandthrive.org",
  "alleng@oaklandthrive.org",
  "phiferd@oaklandthrive.org",
  "brikhow@oaklandthrive.org",
];

// const UserStatisticsLine = (props: any) => {
//   const [userCaseActivity, setUserCaseActivity] = useState({});
//   useEffect(() => {
//     if (props.startDate === null && props.endDate === null) {
//       axiosInstance
//         .get(`/user/userStats?email=${props.user.email}`)
//         .then((res) => {
//           setUserCaseActivity(res.data.userStats.userCaseActivity);
//         });
//     } else if (props.startDate !== null && props.endDate === null) {
//       axiosInstance
//         .get(
//           `/user/userStats?email=${
//             props.user.email
//           }&startDate=${props.startDate.toDate()}`
//         )
//         .then((res) => {
//           setUserCaseActivity(res.data.userStats.userCaseActivity);
//         });
//     } else if (props.startDate !== null && props.endDate !== null) {
//       axiosInstance
//         .get(
//           `/user/userStats?email=${
//             props.user.email
//           }&startDate=${props.startDate.toDate()}&endDate=${props.endDate?.toDate()}`
//         )
//         .then((res) => {
//           setUserCaseActivity(res.data.userStats.userCaseActivity);
//         });
//     }
//   }, [props.startDate, props.endDate]);
//   return props.user.role === "bfc" ? (
//     <div>
//       <Stack direction="row">
//         <Box
//           className="rounded-l-2xl"
//           sx={{ backgroundColor: "#9D2362", width: "20%", margin: 0 }}
//         >
//           <UserProfile user={props.user}></UserProfile>
//         </Box>

//         <Box
//           className="rounded-r-2xl shadow-md inset-0 h-[300px] bg-white"
//           style={{ width: "80%" }}
//         >
//           <InteractiveBarChart
//             data={userCaseActivity}
//             user={props.user}
//             startDate={props.startDate}
//             endDate={props.endDate}
//           />
//         </Box>
//       </Stack>
//     </div>
//   ) : (
//     <></>
//   );
// };
export const userStatsSummary = (userStats: any[]) => {
  const totalStats: any[] = [];
  for (const user of userStats) {
    for (const userStats_item of user.userStats) {
      const item = totalStats.find((item) => item.key === userStats_item.key);
      if (item) {
        item.value += userStats_item.value;
      } else {
        totalStats.push({ ...userStats_item });
      }
    }
  }
  return { userStats: totalStats };
};

export const reorderUsers = (userStats: any[]) => {
  return userOrder
    .map((email) => userStats.find((user: any) => user.email === email))
    .filter((user) => user !== undefined);
};

const ProgramStatistics = () => {
  const [selectedUser, setSelectedUser] = useState({
    firstName: "",
    lastName: "",
  });
  const [selectedUserCases, setSelectedUserCases] = useState([]);
  const [selectedUserActivities, setSelectedUserActivities] = useState([]);
  const [selectedUserFirms, setSelectedUserFirms] = useState<any>([]);
  const [userCaseActivity, setUserCaseActivity] = useState({});
  const [userStats, setUserStats] = useState<any>([]);
  const [users, setUsers] = useState<any[]>([]);
  const { user } = useContext(UserContext);
  const [cardOpen, setCardOpen] = useState<boolean>(false);
  const [bfcReportOpen, setBfcReportOpen] = useState<boolean>(false);
  const [allBfcReportOpen, setAllBfcReportOpen] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Dayjs | null>(
    dayjs().dayOfYear(1)
  );
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [dateFilterFlag, setDateFilterFlag] = useState<boolean>(false);

  const getUserStatus = async (
    startDate: Dayjs | null,
    endDate: Dayjs | null
  ) => {
    try {
      const response = await axiosInstance.get(
        `/user/allUserStats?startDate=${startDate?.format(
          "YYYY-MM-DD"
        )}&endDate=${endDate ? endDate.format("YYYY-MM-DD") : ""}`
      );
      setUserStats(reorderUsers(response.data.userStats));
    } catch (error) {
      console.error("Error fetching user activity statistics:", error);
    }
  };

  useEffect(() => {
    // axiosInstance.get(`/user/allUsers`).then((res) => {
    //   const reorderedUsers = reorderUsers(res.data.users);
    //   setUsers(reorderedUsers);
    // });
    getUserStatus(startDate, endDate);
  }, []);

  const submitDateFilter = () => {
    getUserStatus(startDate, endDate);
    setDateFilterFlag(true);
  };

  // const getSelectedUserCasesAndActivities = async (user: any) => {
  //   const caseResponse = await axiosInstance.get(`/cases?user_id=${user._id}`);
  //   const activityResponse = await axiosInstance.get(
  //     `/activity?user_id=${user._id}`
  //   );

  //   let cases = caseResponse.data.case;
  //   let activities = activityResponse.data.activities;
  //   let firmIds = cases.map((openCase: any) => {
  //     return openCase.firm;
  //   });
  //   let stream_firms: any[] = [];
  //   const response = await fetchInstance(
  //     `${process.env.REACT_APP_API_DOMAIN}/firms/massive_get`,
  //     {
  //       method: "POST",
  //       body: JSON.stringify({ ids: firmIds.join(",") }),
  //     }
  //   );
  //   if (!response.body) {
  //     throw new Error("ReadableStream not supported in this environment.");
  //   }
  //   const reader = response.body.getReader();
  //   const decoder = new TextDecoder("utf-8");
  //   let buffer = "";

  //   while (true) {
  //     const { value, done } = await reader.read();
  //     if (done) break;

  //     buffer += decoder.decode(value, { stream: true });
  //     const lines = buffer.split("\n");
  //     buffer = lines.pop() || ""; // keep incomplete line

  //     for (const line of lines) {
  //       if (line.trim()) {
  //         try {
  //           const obj = JSON.parse(line);
  //           stream_firms.push(obj);
  //         } catch (err) {
  //           console.error("Failed to parse line:", line, err);
  //         }
  //       }
  //     }
  //   }

  //   setSelectedUserFirms(stream_firms);

  //   if (buffer.trim()) {
  //     try {
  //       const obj = JSON.parse(buffer);
  //     } catch (err) {
  //       console.error("Failed to parse final buffer:", buffer, err);
  //     }
  //   }

  //   if (startDate !== null && endDate === null) {
  //     activities = activities.filter((activity: any) => {
  //       return (
  //         dayjs(activity.created_at).utc().format("YYYY-MM-DD") >=
  //         startDate.format("YYYY-MM-DD")
  //       );
  //     });
  //   } else if (startDate !== null && endDate !== null) {
  //     activities = activities.filter((activity: any) => {
  //       return (
  //         dayjs(activity.created_at).utc().format("YYYY-MM-DD") >=
  //           startDate.format("YYYY-MM-DD") &&
  //         dayjs(activity.created_at).utc().format("YYYY-MM-DD") <=
  //           endDate.format("YYYY-MM-DD")
  //       );
  //     });
  //   }
  //   setSelectedUserCases(cases);
  //   setSelectedUserActivities(activities);
  // };

  const handleDateFilterReset = () => {
    setStartDate(dayjs().dayOfYear(1));
    setEndDate(null);
    setDateFilterFlag(false);
    getUserStatus(dayjs().dayOfYear(1), null);
  };

  return (
    <Box>
      <Stack spacing={2}>
        {userStats.length > 0 && (
          <div className="rounded-2xl shadow-md inset-0 h-[300px]">
            {/* <ActivityBarChart data={userCaseActivity} /> */}
            <InteractiveBarChart
              userStats={
                user.role === "admin"
                  ? userStatsSummary(userStats)
                  : userStats.find((stat: any) => stat.userId === user._id)
              }
              user={{ ...user, userId: user._id }}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        )}

        <div className="flex justify-between">
          <div>
            <DateFilterForm
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              onReset={handleDateFilterReset}
              dateFilterFlag={dateFilterFlag}
              setDateFilterFlag={setDateFilterFlag}
              submitDateFilter={submitDateFilter}
            />
          </div>
          {user.role === "admin" ? (
            <div>
              <div className="ml-3 bg-magenta hover:bg-yellow text-white font-bold py-4 px-7 rounded shadow hover:cursor-pointer">
                <button onClick={() => setAllBfcReportOpen(true)}>
                  ALL SBC Report
                </button>
              </div>
            </div>
          ) : (
            <></>
            // <div>
            //   <div className="ml-3 bg-magenta hover:bg-yellow text-white font-bold py-4 px-7 rounded shadow hover:cursor-pointer">
            //     <button
            //       onClick={() => {
            //         setSelectedUser(user);
            //         getSelectedUserCasesAndActivities(user);
            //         setBfcReportOpen(true);
            //       }}
            //     >
            //       My Report
            //     </button>
            //   </div>
            // </div>
          )}
        </div>
        {userStats.map((displayUser: any, index: number) => {
          return (
            <Box key={index}>
              <div>
                <Stack direction="row">
                  <Box
                    className="rounded-l-2xl"
                    sx={{
                      backgroundColor: "#9D2362",
                      width: "20%",
                      margin: 0,
                    }}
                  >
                    <UserProfile user={displayUser}></UserProfile>
                  </Box>

                  <Box
                    className="rounded-r-2xl shadow-md inset-0 h-[300px] bg-white"
                    style={{ width: "80%" }}
                  >
                    <InteractiveBarChart
                      userStats={displayUser}
                      user={displayUser}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </Box>
                </Stack>
              </div>
              {/* <Box
                sx={{
                  width: "80%",
                  float: "right",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  onClick={() => {
                    setSelectedUser(displayUser);
                    // getSelectedUserCasesAndActivities(displayUser);
                    setCardOpen(true);
                  }}
                  sx={{ color: "#9E1F63FF", cursor: "pointer" }}
                >
                  Case Detail
                </Typography>
                {(displayUser.username === user.username ||
                  user.role === "admin") && (
                  <Typography
                    onClick={() => {
                      setSelectedUser(displayUser);
                      // getSelectedUserCasesAndActivities(displayUser);
                      setBfcReportOpen(true);
                    }}
                    sx={{ color: "#9E1F63FF", cursor: "pointer" }}
                  >
                    SBC Report
                  </Typography>
                )}
              </Box> */}
            </Box>
          );
        })}
      </Stack>

      {/* <ThriveModal
        width={1280}
        open={cardOpen}
        setOpen={setCardOpen}
        contentComponent={
          <Box>
            <Box
              sx={{
                textAlign: "center",
                backgroundColor: "#9E1F63FF",
                padding: "3px",
                margin: 0,
                color: "white",
                borderRadius: "5px 5px 0 0",
              }}
            >
              <Typography sx={{ display: "inline-block" }} variant="h4">
                {selectedUser.firstName} {selectedUser.lastName} Cases
              </Typography>
              <Box
                sx={{ display: "inline", float: "right", cursor: "pointer" }}
                onClick={() => {
                  setCardOpen(false);
                }}
              >
                <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: "right",
                marginRight: "10px",
                cursor: "pointer",
                color: "blue",
              }}
            >
              Export All
            </Box>
            <IDEACoreCRM
              openCases={selectedUserCases}
              caseActivities={selectedUserActivities}
              firms={selectedUserFirms}
            ></IDEACoreCRM>
          </Box>
        }
      ></ThriveModal>
      <ThriveModal
        width={1280}
        open={bfcReportOpen}
        setOpen={setBfcReportOpen}
        contentComponent={
          <Box>
            <Box
              sx={{
                textAlign: "center",
                backgroundColor: "#9E1F63FF",
                padding: "3px",
                margin: 0,
                color: "white",
                borderRadius: "5px 5px 0 0",
                marginBottom: "20px",
              }}
            >
              <Typography sx={{ display: "inline-block" }} variant="h4">
                {selectedUser.firstName} {selectedUser.lastName} Report
              </Typography>
              <Box
                sx={{ display: "inline", float: "right", cursor: "pointer" }}
                onClick={() => {
                  setBfcReportOpen(false);
                }}
              >
                <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
              </Box>
            </Box>
            <BFCReportPdf
              user={selectedUser}
              startDate={startDate}
              endDate={endDate}
            />
          </Box>
        }
      ></ThriveModal>*/}
      <ThriveModal
        width={1280}
        open={allBfcReportOpen}
        setOpen={setAllBfcReportOpen}
        contentComponent={
          <Box>
            <Box
              sx={{
                textAlign: "center",
                backgroundColor: "#9E1F63FF",
                padding: "3px",
                margin: 0,
                color: "white",
                borderRadius: "5px 5px 0 0",
                marginBottom: "20px",
              }}
            >
              <Typography sx={{ display: "inline-block" }} variant="h4">
                SBC's Report
              </Typography>
              <Box
                sx={{ display: "inline", float: "right", cursor: "pointer" }}
                onClick={() => {
                  setAllBfcReportOpen(false);
                }}
              >
                <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
              </Box>
            </Box>
            <AllBFCReport startDate={startDate} endDate={endDate} />
          </Box>
        }
      ></ThriveModal>
    </Box>
  );
};
export default ProgramStatistics;
